import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";

export const hasNoStock = (
    realTimeStockAvailable?: boolean,
    stockLevel?: CloudStockLevel | null,
    realTimeStock?: number
) => {
    return (
        (!realTimeStockAvailable && stockLevel === null) ||
        (!realTimeStockAvailable && stockLevel === CloudStockLevel.NoStock) ||
        (!realTimeStockAvailable &&
            stockLevel === CloudStockLevel.UnknownStock) ||
        (realTimeStockAvailable && realTimeStock! <= 0)
    );
};
